import AbilityScoreManagerManual from './AbilityScoreManagerManual';

export default AbilityScoreManagerManual;
export { AbilityScoreManagerManual };
